import React from 'react';
import InputField from '../InputField/InputField';
import SelectField from '../SelectField/SelectField';
import ButtonGeneral from '../buttons/ButtonGeneral';

/**
 * Estados reales de una solicitud de marca (ApplicationStatus del backend,
 * api/brand_registrations/models/brand_registration_application.py).
 */
export const APPLICATION_STATUS_OPTIONS = [
    { value: 'pending', label: 'Pendiente' },
    { value: 'paid', label: 'Pago inicial realizado' },
    { value: 'assigned', label: 'Asignado a abogado' },
    { value: 'in_progress', label: 'En análisis' },
    { value: 'verified', label: 'Verificación completada' },
    { value: 'feasibility_negative', label: 'Factibilidad negativa' },
    { value: 'payment_pending', label: 'Esperando pago completo' },
    { value: 'payment_confirmed', label: 'Pago completo confirmado' },
    { value: 'preparing_documents', label: 'Preparando documentos INAPI' },
    { value: 'submitted_inapi', label: 'Presentado en INAPI' },
    { value: 'formal_examination', label: 'Examen de forma INAPI' },
    { value: 'published', label: 'Publicado en Diario Oficial' },
    { value: 'opposition_period', label: 'Período de oposición' },
    { value: 'substantive_examination', label: 'Examen de fondo INAPI' },
    { value: 'approved_inapi', label: 'Aprobado por INAPI' },
    { value: 'rejected_inapi', label: 'Rechazado por INAPI' },
    { value: 'completed', label: 'Completado' },
    { value: 'cancelled', label: 'Cancelado' }
];

interface BrandRegistrationFiltersProps {
    search: string;
    lawyer?: string;
    status: string;
    onSearchChange: (value: string) => void;
    onLawyerChange?: (value: string) => void;
    onStatusChange: (value: string) => void;
    onFilter?: () => void;
}

const BrandRegistrationFilters: React.FC<BrandRegistrationFiltersProps> = ({
    search,
    lawyer = '',
    status,
    onSearchChange,
    onLawyerChange,
    onStatusChange,
    onFilter
}) => {
    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Buscar"
                        value={search}
                        onChange={onSearchChange}
                        placeholder="Buscar por ID"
                        size="small"
                    />
                </div>

                {onLawyerChange && (
                    <div className="col-md-auto">
                        <SelectField
                            value={lawyer}
                            onChange={(value) => onLawyerChange(value as string)}
                            size="small"
                        >
                            <option value="">Todos los abogados</option>
                            <option value="vannia">Vannia Jauregui</option>
                        </SelectField>
                    </div>
                )}

                <div className="col-md-auto">
                    <SelectField
                        value={status}
                        onChange={(value) => onStatusChange(value as string)}
                        size="small"
                    >
                        <option value="">Todos los estados</option>
                        {APPLICATION_STATUS_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </SelectField>
                </div>

                <div className='col-md-auto'>
                    <div>
                        <ButtonGeneral
                            onClick={onFilter || (() => console.log('Filter clicked'))}
                            title="Buscar"
                            variant="outline"
                            size="small"
                            icon="fa-search"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandRegistrationFilters;
